import { render, staticRenderFns } from "./ProposalsProducts.vue?vue&type=template&id=687860f3&scoped=true&"
import script from "./ProposalsProducts.vue?vue&type=script&lang=js&"
export * from "./ProposalsProducts.vue?vue&type=script&lang=js&"
import style0 from "./ProposalsProducts.vue?vue&type=style&index=0&id=687860f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687860f3",
  null
  
)

export default component.exports